export const percentsCounter = (count, all) => {
  if (all === 0 || count === 0 ) {
    return 0;
  } else {
    return Math.round(count / all * 100);
  }
};
